export const GLOBAL_LINKS = {
  zendesk: "https://basefood.zendesk.com/hc/ja/requests/new",
};
